import { toDate } from './timestampUtils';

/**
 * Whether a newly observed team-update message should raise a live notification.
 * Historical backlog (cache hydration, resubscribe catch-up) must not alert.
 */
export function shouldNotifyLiveTeamUpdateMessage(options: {
  messageId: string;
  authorId: string;
  currentUserId: string;
  createdAt: unknown;
  /** Epoch ms when this listener was attached. */
  listenerAttachedAtMs: number;
  alreadySeenIds: Set<string>;
}): boolean {
  const { messageId, authorId, currentUserId, createdAt, listenerAttachedAtMs, alreadySeenIds } =
    options;
  if (!messageId || alreadySeenIds.has(messageId)) return false;
  if (!currentUserId || authorId === currentUserId) return false;
  const createdMs = toDate(createdAt as Parameters<typeof toDate>[0])?.getTime() || 0;
  // No timestamp yet (pending write) or clearly older than this session's listener.
  if (!createdMs || createdMs < listenerAttachedAtMs) return false;
  return true;
}
